import React from 'react';
const pillars = [{
  emoji: '⚡',
  title: 'Practical diagnostic resources',
  body: 'Find the relevant system, reference or troubleshooting path when you need it.'
}, {
  emoji: '🔍',
  title: 'Structured diagnostic processes',
  body: 'Move from symptom or warning to a clearer diagnostic direction.'
}, {
  emoji: '🚗',
  title: '6 diagnostic areas',
  body: 'Systems, battery, drive, charging, thermal management and fault finding.'
}, {
  emoji: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the system whenever another EV or hybrid fault appears.'
}];
export function ChangeSection() {
  return <section className="bg-ev-black px-4 py-4 text-white" data-id="element-29" data-mp="7wl4fxp3kri3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-30" data-mp="7x4n5gmknjx6">
        <h2 className="font-display text-[21px] leading-tight text-white sm:text-3xl" data-id="element-31" data-mp="1xbsp0nxjdjgy">
          This Isn&apos;t Just Another EV &amp; Hybrid Ebook
        </h2>
        <p className="mb-3 font-display text-[19px] leading-tight text-ev-green sm:text-[26px]" data-id="element-32" data-mp="229uf3stdqj1x">
          It&apos;s a Ready-To-Use Diagnostic System.
        </p>
        <ul className="grid grid-cols-1 gap-1.5 text-left sm:grid-cols-2" data-id="element-33" data-mp="39ahhvolu574x">
          {pillars.map(pillar => <li key={pillar.title} className="rounded-md bg-ev-panel px-3 py-2" data-id="element-34" data-mp="3n1mba8ym136t">
              <h3 className="font-cond text-[16px] tracking-wide text-ev-neon sm:text-lg" data-id="element-35" data-mp="3i4vtnh75pzja">
                {pillar.emoji} {pillar.title}
              </h3>
              <p className="text-[12px] font-medium leading-snug text-ev-steel sm:text-[14px]" data-id="element-36" data-mp="2ug34c3l1ipxn">
                {pillar.body}
              </p>
            </li>)}
        </ul>
        <p className="mt-2.5 font-cond text-lg tracking-wide text-white sm:text-xl" data-id="element-37" data-mp="34acxhnht3s9f">
          Less searching. Less guessing. More diagnostic clarity.
        </p>
      </div>
    </section>;
}